import { BaseInit } from "../shared/BaseInit";
import { IAsideMenuRender } from "../shared/components/definitions/app/IAsideMenuRender";
import { ClienteAsideMenuRender } from "./components/ClienteAsideMenuRender";
import { LoginAuthResponse } from "./response/LoginAuthResponse";

/** Días antes del vencimiento desde los que se avisa (igual a `LicenciaPlataforma.DiasAvisoPrevio` del Server). */
const DIAS_AVISO_PREVIO = 15;
const MS_POR_DIA = 86_400_000;

/** Inicialización de la app **Cliente**. Concreta `BaseInit` con el menú
 *  lateral propio del cliente y el aviso de vencimiento de la licencia. */
export class ClienteInit extends BaseInit<LoginAuthResponse> {
  protected asideMenuRender: IAsideMenuRender<LoginAuthResponse> =
    new ClienteAsideMenuRender();

  /** Aviso de vencimiento de la licencia desde 15 días antes (demo o paga).
   *  Mismo criterio que el Server: fecha UTC, vale hasta el día de vencimiento
   *  inclusive. Si ya venció no avisa: el Server corta el acceso en el login. */
  protected override getAviso(response: LoginAuthResponse): string | null {
    if (response.fechaVencimientoPlataforma == null) return null;

    const vence = new Date(response.fechaVencimientoPlataforma);
    const venceDia = Date.UTC(vence.getUTCFullYear(), vence.getUTCMonth(), vence.getUTCDate());
    const hoy = new Date();
    const hoyDia = Date.UTC(hoy.getUTCFullYear(), hoy.getUTCMonth(), hoy.getUTCDate());
    const diasRestantes = Math.round((venceDia - hoyDia) / MS_POR_DIA);
    if (diasRestantes < 0 || diasRestantes > DIAS_AVISO_PREVIO) return null;

    const fecha = [
      String(vence.getUTCDate()).padStart(2, "0"),
      String(vence.getUTCMonth() + 1).padStart(2, "0"),
      vence.getUTCFullYear(),
    ].join("/");
    const cuando = diasRestantes === 0
      ? "vence hoy"
      : `en ${diasRestantes} ${diasRestantes === 1 ? "día" : "días"}`;
    const texto = response.isDemoPlataforma
      ? `Tu licencia de demostración vence el ${fecha} (${cuando}). Contacta a tu asesor comercial para contratar un plan.`
      : `Tu licencia vence el ${fecha} (${cuando}). Contacta a tu asesor comercial para renovarla.`;

    return `<div class="sx-alert sx-alert-warning sx-aviso-app" role="status">
      <i class="ph ph-warning" aria-hidden="true"></i>
      <div>${texto}</div>
    </div>`;
  }
}
